module.exports = __webpack_public_path__ + "img/11.fc5751dc.jpeg";